import { configureStore, combineReducers  } from '@reduxjs/toolkit'
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage'
import { listenerMiddleware } from './listeners';

// Import your reducers
import authReducer from './slices/authSlice'
import languageReducer from './slices/languageSlice';
import userReducer from './slices/userSlice'
import userPermissionReducer from './slices/userPermissionSlice';
import customerReducer from './slices/customerSlice';
import siteReducer from './slices/siteSlice';
import locationReducer from './slices/locationSlice';
import selectionReducer from './slices/selectionSlice';
import deviceReducer from './slices/deviceSlice';
import unauthorizedReducer from './slices/unauthorizedSlice';
import { productsReducer } from './slices/productsSlice';
import { walkdownReducer } from './walkdownSlice';
import turnaroundsReducer from './slices/turnaroundsSlice';
import turnaroundDetailReducer from './slices/turnaroundDetailSlice';
import siteDocumentationReducer from './slices/siteDocumentationSlice';


const appReducer = combineReducers({
  auth: authReducer,
  language: languageReducer,
  user: userReducer,
  userpermissions: userPermissionReducer,
  customer: customerReducer,
  site: siteReducer,
  location: locationReducer,
  selection: selectionReducer,
  device: deviceReducer,
  walkdown: walkdownReducer,
  unauthorized: unauthorizedReducer,
  products: productsReducer,
  turnarounds: turnaroundsReducer,
  turnaroundDetail: turnaroundDetailReducer,
  siteDocumentation: siteDocumentationReducer,
});


export const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: any) => {
  if (action.type === 'LOGOUT') {
    state = undefined; // Clears all slices
  }
  return appReducer(state, action);
};


const persistConfig = {
  key: 'root',          // storage root key
  storage,              // localStorage (web)
   whitelist: ['language','user','customer','userpermissions','selection'], // Slices to persist
  blacklist: ['unauthorized'], // Prevent unauthorized modal state from persisting
  // version: 1,        // optional: add version if you plan migrations
  // migrate: async (state) => state, // optional migration function
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Silence non-serializable warnings for redux-persist’s internal actions
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
    // }).prepend(listenerMiddleware.middleware),
  // devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch
